// **********************************************************
//  Intro slider
// **********************************************************
/* eslint-disable */
$(function () {
  new Swiper('.intro-slider', {
    effect: 'fade',
    loop: true,
    autoplay: {
      delay: 4000,
    },
    pagination: {
      el: '.intro-slider__pagination',
      clickable: true,
    },
  });
});
/* eslint-enable */
